module.exports = (el) ->
  if document.body.createTextRange
    range = document.body.createTextRange()
    range.moveToElementText(el)
    range.select()
  else
    selection = window.getSelection()
    range = document.createRange()
    range.selectNodeContents(el)
    selection.removeAllRanges()
    selection.addRange(range)

  return
